import { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
export const useAlgoliaUserToken = (id) => {
  const [token, setToken] = useState("");
  useEffect(() => {
    if (id) {
      // Use logged-in user ID (or hash it if preferred)
      setToken(`${id}`);
    } else if (typeof window !== "undefined") {
      const key = "algolia_user_token";
      let storedToken = localStorage.getItem(key);
      if (!storedToken) {
        storedToken = uuidv4();
        localStorage.setItem(key, storedToken);
      }
      setToken(storedToken);
    } else {
      setToken("Guest-SSR");
    }
  }, [id]);
  return token;
};
